import classNames from "classnames";
import { validate, validateEmail, validateURL } from "../../utils/validate";
import { DComponent } from "../DComponent";

export default class InputField extends DComponent {
  constructor({
    parent,
    id,
    label = "",
    type = "",
    name = "",
    defaultValue = "",
    maxlength = 250,
    invalid = "",
    tabIndex = "",
    placeholder = "",
    isRequired = false,
    className = "",
    autoScroll = false,
    scrollPadding,
    onKeyup = () => { },
    onChange = () => { },
    scrollParent,
    inline = false,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("InputField", className, {
        "is-required": isRequired,
        "inline": inline,
      }),
      type: type,
      label: label,
      name: name,
      tabIndex: tabIndex,
      invalid: invalid,
      maxlength: maxlength,
      placeholder: placeholder,
      autoScroll: autoScroll ? " autoscroll" : "",
      scrollPadding: scrollPadding !== undefined ? ` scrollpadding="${scrollPadding}"` : "",
      scrollParent: scrollParent ? ` scrollparent="${scrollParent}"` : "",
    });
    this.type = type;
    this.name = name;
    this.defaultValue = defaultValue;
    this.placeholder = placeholder;
    this.isRequired = isRequired;
    this.onKeyup = onKeyup;
    this.onChange = onChange;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "InputField");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    $("input", this.element).on("keyup", (e) => {
      let type = e.target.type;
      switch (type) {
        case InputField.TYPE.EMAIL:
          validate({ selector: e.target, validator: validateEmail, showInvalid: this.isRequired })
          break;
        case InputField.TYPE.URL:
          validate({ selector: e.target, validator: validateURL, showInvalid: this.isRequired })
          break;
        default:
          validate({ selector: e.target, showInvalid: this.isRequired })
          break;
      }
      typeof this.onKeyup == "function" && this.onKeyup(this.getValue());

    })
    $("input", this.element).on("change", (e) => {
      let value = this.getValue();
      typeof this.onChange == "function" && this.onChange(value);
      value ? this.element.addClass("has-value") : this.element.removeClass("has-value");
    });

    this.defaultValue && this.setValue(this.defaultValue);
  }

  getValue() {
    return $("input", this.element).val();
  }

  setValue(value) {
    value ? this.element.addClass("has-value") : this.element.removeClass("has-value");
    $("input", this.element).val(value);
  }

  setLabel(label, placeholder, invalid) {
    $(".label span", this.element).attr("data-i18n", "[html" + label);
    $(".label span", this.element).text($.i18n(label));
    if (placeholder) {
      $("input", this.element).attr("data-i18n", "[placeholder]" + placeholder);
      $("input", this.element).attr("placeholder", $.i18n(placeholder));
    }
    if (invalid) {
      $(".invalid-feedback", this.element).attr("data-i18n", "[html" + invalid);
      $(".invalid-feedback", this.element).text($.i18n(invalid));
    }
  }

  clearInput() {
    $("input", this.element).removeClass("is-invalid");
    $("input", this.element).val("");
  }

  focus() {
    $("input", this.element).focus();
  }

  isValidate(isShowValid = true, isFocus = true) {
    switch (this.type) {
      case InputField.TYPE.EMAIL:
        if (!this.isRequired && !this.getValue()) return true;
        return validate({ selector: $("input", this.element), validator: validateEmail, showInvalid: isShowValid, isFocus: isFocus })

      case InputField.TYPE.URL:
        if (!this.isRequired && !this.getValue()) return true;
        return validate({ selector: $("input", this.element), validator: validateURL, showInvalid: isShowValid, isFocus: isFocus })
      default:
        if (!this.isRequired) return true;
        return validate({ selector: $("input", this.element), showInvalid: isShowValid, isFocus: isFocus })
    }
  }

  static TYPE = {
    EMAIL: "email",
    TEL: "tel",
    URL: "url",
  }
}